//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "spot_space_order_detail",
  data(){
    const validatePaidVoucherFileContent = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('上传文件不能为空'))
      } else {
        return callback()
      }
    }
    return{
      radio: '1',
      currentNum: 1,
      typeClicked1: true,
      typeClicked2: true,
      typeClicked3: true,
      typeClicked4: true,
      isDangerous: '是',
      num4: '',
      num3: '',
      num2: '',
      num1: '',
      item: {
        spotResourceInfo:{
          slotType: ''
        }
      },
      orderNo: '',
      orderForm: {
        paidVoucherFileContent: ''
      },
      rules: {
        paidVoucherFileContent: [{ required: true, validator: validatePaidVoucherFileContent, trigger: 'blur' }],
      },
      fileList: [],
      uploadId: '',
      showUploadDialog: false,
      showCancelOrderDialog : false,
      dialogVisible: false,
      dialogImageUrl: '',
      showCancelTip: false,
      tipSubject: '',
      tipContent: ''
    }
  },
  methods:{
    async getSpotSpaceOrderDetail () {
      try {
        const params = {
          orderNo: this.orderNo
        }
        const res = await this.$axios.get('/bk/spotOrder/getDetail', {
          params: params
        });

        if(res.orderNo){
          this.item = res;
        }
        console.log(res)
      } catch (e) {
        console.log(e, 'e')
      }
    },
    uploadpaidVoucherFile(item){
      this.uploadId = item.id;
      this.showUploadDialog = true;
    },
    getFile (file, fileList, num) {
      this.getBase64(file.raw).then(res => {
        const params = res
        console.log(params, 'params')
        this.proofImage = params
        if (num === 1) {
          this.orderForm.paidVoucherFileContent = this.proofImage
        }

      })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleUploadRemove (file, fileList, num) {
      this.proofImage = ''
      if (num === 1) {
        this.orderForm.paidVoucherFileContent = this.proofImage
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    async upload(){
      await this.$refs.orderForm.validate();
      const params = {
        id: this.item.id,
        paidVoucherFileContent: this.orderForm.paidVoucherFileContent
      }
      const result = await this.$axios.post('/bk/spotOrder/uploadPaidVoucher', params);
      if(result === 401){
        localStorage.setItem("prePath", location.hash.split('#').length > 1 ? location.hash.split('#')[1] : '');
        this.$router.push({
          path:'/login'
        })
      }else if(result === 'success'){
        this.orderForm = {
          paidVoucherFileContent: '',
        }
        this.showUploadDialog = false;
        this.dialogImageUrl = '';
        this.dialogVisible = false;
        location.reload();
      }else{
        this.$message.error(this.$t('t.contact_IT'))
      }
    },
    async cancelOrder(){
      console.log(this.cancelItem)
      try {
        const params ={
          id: this.item.id
        }
        const Result = await this.$axios.post('/bk/spotOrder/cancelOrder', params);
        if(Result === 401){
          await this.$router.push({
            path: '/login'
          })
        }else if(Result === 'success' ){
          this.showCancelOrderDialog= false;
          this.tipSubject = this.$t('s.spotSpace_order_cancel_send_subject');
          this.tipContent = this.$t('s.spotSpace_order_cancel_send_context');
          this.showCancelTip = true;
        }else {
          this.$message.error('Cancel Order Fail')
        }
      } catch (e) {
        console.log(e, 'e')
      }
    },
    handleClose() {
        this.showCancelTip = false;
        this.$router.push({
            path:'/spotSpaceOrder'
        })
    },
    toReOrder(){
      this.$router.push({
        path:'/spotSpace'
      })
    },
    openCancelOrderDialog(item){
      this.showCancelOrderDialog = true;
    },
    downloadVoucher(url){
      window.open(url);
    }
  },
  created() {
    if(localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang');
    }
    this.orderNo = this.$route.params.orderNo;
    this.getSpotSpaceOrderDetail();
    console.log(this.orderNo)
  },
  computed: {
    currentLang () {
      return this.$i18n.locale
    }
  }
}
